<template>
  <div class="min-h-screen w-full flex justify-center items-start p-6">
    <div class="w-full bg-white rounded-lg shadow-lg overflow-hidden">
      <div class="max-h-[calc(100vh-3rem)] overflow-y-auto px-6 py-12">
        <h1 class="text-3xl font-bold text-gray-900 mb-6">
          User Data Deletion Instructions
        </h1>

        <p class="text-gray-700 mb-6">
          If you wish to delete your account and associated data, follow the
          instructions below based on your role:
        </p>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            Deleting Your Store
          </h2>
          <p class="text-gray-700 mb-6">
            Store owners can delete their store by navigating to
            <strong>Store Settings</strong> and selecting the
            <strong>Delete Store</strong> option. This action is irreversible.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            Deleting Your Account
          </h2>
          <p class="text-gray-700 mb-6">
            Users can delete their account from the
            <strong>User Profile</strong> page. Account deletion is subject to
            admin verification to ensure no pending issues exist.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            Disconnecting Social Media Accounts
          </h2>
          <p class="text-gray-700 mb-6">
            If you disconnect your social media accounts, your data will be
            moved to a temporary database. Your information will be retained for
            <strong>one month</strong> before permanent deletion.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            Turning Off Automation
          </h2>
          <p class="text-gray-700 mb-6">
            Users who do not want their store automated for marketing can
            disable this feature by switching off
            <strong>Airplane Mode</strong> in their settings.
          </p>
        </section>

        <section>
          <h2 class="text-2xl font-semibold text-gray-900 mb-2">
            Requesting Data Deletion
          </h2>
          <p class="text-gray-700 mb-6">
            If you require assistance in deleting your data, contact us at:
          </p>
          <p class="text-gray-700 font-medium">
            📧 Email:
            <a
              href="mailto:support@tryhisell.com"
              class="text-blue-600 hover:underline"
              >support@tryhisell.com</a
            >
          </p>
        </section>

        <p class="text-gray-500 text-sm mt-8">Last updated: March 2025</p>
      </div>
    </div>
  </div>
</template>
